export default {
  heading: 'Meet The Animals You’ve Helped',
  sponsoredPets: 'Sponsored Pets',
  sponsoredText:
    'Certificates are updated every quarter. Check back often to see our progress.',
  contributeNow: 'Start contributing right now!',
};
